module.exports = __webpack_public_path__ + "media/Instruction_01.91c5149f.mp3";